import { generateUUID } from '@/domain/shared/generateUUID';
import { useAddToCart } from '@/composables/useAddToCart';
import { useConfigStore } from '@/store/config.store';
import ObsidianApi from 'obsidian-api';
import type { ICantorAPI } from '@/obsidianApi/ICantorAPI';
import type { IObsidianApplicationSideAPI } from '@/obsidianApi/IObsidianApplicationSideAPI';
import type { ICart } from '@/typescript/interfaces/ICart';

/**
 * When application run as an iframe, IFrameApi is a way to communicate
 * between application (which is in iframe) and integration
 * Usually iframe is the app developed by Wanadev, integration is developed by client or BO team.
 * Documentation https://wanadev.github.io/obsidian-api/index.html
 */
const api: Partial<ICantorAPI> = {
    echo: (text: string): string => {
        '@api';

        return text;
    },
};

const IFrameApi = ObsidianApi.$extend(api);
const iFrameApi = new IFrameApi() as IObsidianApplicationSideAPI;

iFrameApi.addApiMethod('addToCart', async (): Promise<ICart> => {
    const configStore = useConfigStore();
    let { projectId } = configStore;
    if (!projectId) {
        projectId = generateUUID();
        configStore.projectId = projectId;
    }
    const { addToCart } = useAddToCart();
    return addToCart(projectId);
});

iFrameApi.addApiMethod('showPreview', (): void => {
    const configStore = useConfigStore();
    configStore.isBATModalVisible = true;
});
export { iFrameApi };
